import { format, getPattern, parse, validate } from '@philips-internal/oswald-ui-model/lib/formatters/date/date';
async function preventFutureDateValidate(value) {
    const currentDate = new Date();
    const minimumDate = new Date('1900-01-01');
    const valueDate = new Date(value);
    const validationResults = await validate(value);
    const isValidDate = validationResults[0].valid;
    const valid = valueDate <= currentDate && valueDate >= minimumDate && isValidDate;
    return [{
            message: !valid ? 'results.validator.invalid-date' : '',
            name: 'prevent-future-date',
            valid,
        }];
}
const PreventFutureDateFormatter = { format, parse, validate: preventFutureDateValidate, getPattern };
export default PreventFutureDateFormatter;
//# sourceMappingURL=prevent-future-date-formatter.js.map